import React from 'react'
import parse from 'html-react-parser'
import AvailableCoachCard from './AvailableCoachCard'
import BusyCoachCard from './BusyCoachCard'

/**
 * Renders available + busy coach sections (and empty-state copy).
 * Connection / filtering / selection handlers stay in parent orchestrators.
 */
function CoachListSections({
  availableCoaches,
  busyCoaches,
  getJobTitle,
  getBusyMessage,
  isCoachExpanded,
  onToggleExpanded,
  onSelect,
  userCareerDevelopment = false,
  mediaAvailable = true,
  actionLabels,
  moreInfoLabel,
  showLessLabel,
  expandedLabels,
  translateSkill,
  availableHeading,
  busyHeading,
  emptyMessageHtml,
  showBusyPauseIcon = true,
  grayscaleBusyAvatar = true,
  availableHeadingClassName = 'text-lg font-medium',
  busyHeadingClassName = 'text-lg font-medium text-gray-600',
}) {
  const hasAnyCoaches = availableCoaches.length > 0 || busyCoaches.length > 0

  if (!hasAnyCoaches) {
    return (
      <div className="py-8 text-center">
        <p className="text-gray-500">
          {emptyMessageHtml ? parse(emptyMessageHtml) : null}
        </p>
      </div>
    )
  }

  return (
    <div className="space-y-4">
      {availableCoaches.length > 0 && (
        <>
          <h3 className={availableHeadingClassName}>{availableHeading}</h3>
          <div className="grid grid-cols-1 gap-3">
            {availableCoaches.map((coach) => (
              <AvailableCoachCard
                key={coach.easyrtcid}
                coach={coach}
                jobTitle={getJobTitle(coach)}
                isExpanded={isCoachExpanded(coach.easyrtcid)}
                onToggleExpanded={onToggleExpanded}
                onSelect={onSelect}
                userCareerDevelopment={userCareerDevelopment}
                mediaAvailable={mediaAvailable}
                actionLabels={actionLabels}
                moreInfoLabel={moreInfoLabel}
                showLessLabel={showLessLabel}
                expandedLabels={expandedLabels}
                translateSkill={translateSkill}
              />
            ))}
          </div>
        </>
      )}

      {busyCoaches.length > 0 && (
        <>
          <h3 className={busyHeadingClassName}>{busyHeading}</h3>
          <div className="grid grid-cols-1 gap-3">
            {busyCoaches.map((coach) => (
              <BusyCoachCard
                key={coach.easyrtcid}
                coach={coach}
                jobTitle={getJobTitle(coach)}
                busyMessage={getBusyMessage(coach)}
                showPauseIcon={showBusyPauseIcon}
                grayscaleAvatar={grayscaleBusyAvatar}
              />
            ))}
          </div>
        </>
      )}
    </div>
  )
}

export default CoachListSections
